import DSIconsLine, { DSIconsLineConfig } from '@petz/ds-icons/line'
import DSIconsSolid, { DSIconsSolidConfig } from '@petz/ds-icons/solid'
import { PTZTokensColor, PTZTokensColorConfig } from '@petz/ds-tokens/petz'

export enum BrandAcronym {
  Petz = 'ptz',
  Seres = 'srs',
}

export enum BrandVariant {
  Primary = 'primary',
  Darker = 'darker',
}

export enum BrandName {
  Seres = 'seres',
  AdotePetz = 'adotepetz',
  Petz = 'petz',
}

export const BrandConfigList = {
  Acronym: Object.values(BrandAcronym),
  Variant: Object.values(BrandVariant),
  Name: Object.values(BrandName),
}

export const BrandConfig = {
  Acronym: BrandAcronym,
  Variant: BrandVariant,
  Name: BrandName,
}

export enum IconAlign {
  Left = 'left',
  Right = 'right',
}

export enum IconSize {
  Size3xs = '3xs',
  Size2xs = '2xs',
  SizeXs = 'xs',
  SizeSm = 'sm',
  SizeMd = 'md',
  SizeLg = 'lg',
  SizeXl = 'xl',
  Size2xl = '2xl',
  Size3xl = '3xl',
  SizeMax = 'max',
}

export enum IconVariant {
  Solid = 'solid',
  Line = 'line',
}

export const IconConfigList = {
  Align: Object.values(IconAlign),
  Brand: BrandConfigList.Name,
  Color: PTZTokensColor,
  Name: [...DSIconsLine.Name, ...DSIconsSolid.Name],
  Size: Object.values(IconSize),
  Variant: Object.values(IconVariant),
}

export const IconConfig = {
  Align: IconAlign,
  Brand: BrandConfig.Name,
  Color: PTZTokensColorConfig,
  Name: { ...DSIconsLineConfig, ...DSIconsSolidConfig },
  Size: IconSize,
  Variant: IconVariant,
}
